import { useRef, useState } from "react";

import { subirPapelFirmado } from "../../services/herramientas";

/* Subir la foto del papel firmado de una entrega (P-311).
 *
 * Nico: *«se imprima, se firma y se almacena»*. Lo almacenado es una foto
 * sacada con el teléfono —o el PDF del escáner—, en el bucket privado
 * `constancias`. Un `<input type=file>` y nada más: en el teléfono ofrece la
 * cámara sola, y en la compu, elegir el archivo.
 */
export default function SubirPapel({ entrega, onSubido, chico = false }) {
  const [subiendo, setSubiendo] = useState(false);
  const [error, setError] = useState("");
  const input = useRef(null);

  const elegido = async (e) => {
    const archivo = e.target.files?.[0];
    e.target.value = "";
    if (!archivo) return;
    setSubiendo(true);
    setError("");
    const r = await subirPapelFirmado(entrega, archivo);
    setSubiendo(false);
    if (!r.ok) { setError(r.error || "No pude subir la foto."); return; }
    onSubido?.(r.fila);
  };

  return (
    <span className="cst-subir">
      <button type="button" disabled={subiendo}
              className={`hrr-btn hrr-btn--principal${chico ? " hrr-btn--chico" : ""}`}
              onClick={() => input.current?.click()}>
        {subiendo ? "Subiendo…" : "📷 Subir el papel firmado"}
      </button>
      <input ref={input} type="file" accept="image/*,application/pdf" hidden
             aria-label={`Foto del papel firmado de la entrega ${entrega?.id}`}
             onChange={elegido} />
      {error && <span className="hrr-aviso" role="alert">{error}</span>}
    </span>
  );
}
